<template>
  <v-card class="password-generator tools-view-card">
    <ToolbarHeader :name="'Password Generator'"/>
    <v-container>
      <section class="ma-5">
        <v-form
        >
          <v-row justify="center">
            <v-col cols="12"
                   sm="12"
                   md="8">
              <v-text-field
                  required
                  v-model="password"
                  name="Password"
                  id="password-generator_value"
                  label="Your unique password"
              />
            </v-col>
            <v-col cols="12"
                   sm="12"
                   md="2">
              <v-btn
                  color="primary"
                  class="mt-1 w-100"
                  @click="generatePassword"
              >
                Generate
              </v-btn>
            </v-col>
            <v-col cols="12"
                   sm="12"
                   md="2">
              <v-btn
                  color="primary"
                  class="mt-1 w-100"
                  @click="copy('password-generator_value')"
              >
                <v-icon dark>
                  mdi-content-copy
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12"
                   sm="3"
                   md="1">
              <v-text-field
                  v-model="passwordGeneratorOptions.length"
                  name="Length"
                  id="password-generator_length"
                  label="Length"
              />
            </v-col>
            <v-col cols="12"
                   sm="3"
                   class="ml-5"
                   md="1">
              <v-checkbox
                  v-model="passwordGeneratorOptions.numbers"
                  label="Numbers"
              />
            </v-col>
            <v-col cols="12"
                   sm="3"
                   class="ml-5"
                   md="1">
              <v-checkbox

                  v-model="passwordGeneratorOptions.symbols"
                  label="Symbols"
              />
            </v-col>
            <v-col cols="12"
                   sm="3"
                   class="ml-5"
                   md="1">
              <v-checkbox

                  v-model="passwordGeneratorOptions.lowercase"
                  label="Lowercase"
              />
            </v-col>
            <v-col cols="12"
                   sm="3"
                   class="ml-5"
                   md="1">
              <v-checkbox

                  v-model="passwordGeneratorOptions.uppercase"
                  label="Uppercase"
              />
            </v-col>
            <v-col cols="12"
                   sm="3"
                   class="ml-5"
                   md="1">
              <v-checkbox
                  v-model="passwordGeneratorOptions.strict"
                  label="Strict"
              />
            </v-col>
            <v-col cols="12"
                   sm="3"
                   md="3">
              <v-checkbox
                  v-model="passwordGeneratorOptions.excludeSimilarCharacter"
                  label="Exclude Similar Character"
              />
            </v-col>

          </v-row>
        </v-form>
      </section>
    </v-container>
  </v-card>
</template>

<script>
import ToolbarHeader from "@/components/Toolbar-Header";
import generatePassword from 'generate-password';
import {copyMixin} from "@/mixins/copyMixin";


export default {
  name: "Password-Generator",
  mixins: [copyMixin],
  components: {ToolbarHeader},
  data: () => ({
    password: '',
    passwordGeneratorOptions: {
      length: 30,
      numbers: true,
      symbols: false,
      lowercase: true,
      uppercase: true,
      excludeSimilarCharacter: false,
      strict: false
    }
  }),
  created() {
    this.generatePassword();
  },
  methods: {
    generatePassword() {
      this.password = generatePassword.generate({
        length: this.passwordGeneratorOptions.length,
        numbers: this.passwordGeneratorOptions.numbers,
        symbols: this.passwordGeneratorOptions.symbols,
        lowercase: this.passwordGeneratorOptions.lowercase,
        uppercase: this.passwordGeneratorOptions.uppercase,
        excludeSimilarCharacter: this.passwordGeneratorOptions.excludeSimilarCharacter,
        strict: this.passwordGeneratorOptions.strict
      })
    }
  }
}
</script>

<style scoped>

</style>
